import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { requestCreatePatientDocument } from 'redux/modules/patientsDocuments';

// Actions
export const FETCH_PATIENT_MESSAGES = 'FETCH_PATIENT_MESSAGES';
export const FETCH_PATIENT_MESSAGES_SUCCESS = 'FETCH_PATIENT_MESSAGES_SUCCESS';
export const FETCH_PATIENT_MESSAGES_FAIL = 'FETCH_PATIENT_MESSAGES_FAIL';
export const RECIEVE_PATIENT_MESSAGE = 'RECIEVE_PATIENT_MESSAGE';
export const CLEAR_PATIENT_MESSAGES = 'CLEAR_PATIENT_MESSAGES';
export const CREATE_PATIENT_MESSAGE = 'CREATE_PATIENT_MESSAGE';
export const CREATE_PATIENT_MESSAGE_SUCCESS = 'CREATE_PATIENT_MESSAGE_SUCCESS';
export const CREATE_PATIENT_MESSAGE_FAIL = 'CREATE_PATIENT_MESSAGE_FAIL';

// Reducer
export default function patientsMessagesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PATIENT_MESSAGES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PATIENT_MESSAGES_SUCCESS:
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          patientID: payload.patientID,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PATIENT_MESSAGES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_PATIENT_MESSAGES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case CREATE_PATIENT_MESSAGE_SUCCESS:
    case RECIEVE_PATIENT_MESSAGE: {
      console.log(state.patientID);
      console.log(payload);
      if (state.patientID !== payload['Patient ID']) {
        return state;
      }
      const newData = [
        payload,
        ...state.data.slice(0, state.data.length),
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchPatientMessages(payload) {
  return { type: FETCH_PATIENT_MESSAGES, payload };
}

export function fetchPatientMessagesSuccess(payload) {
  return { type: FETCH_PATIENT_MESSAGES_SUCCESS, payload };
}

export function fetchPatientMessagesFail(payload) {
  return { type: FETCH_PATIENT_MESSAGES_FAIL, payload };
}

export function recievePatientMessage(payload) {
  return { type: RECIEVE_PATIENT_MESSAGE, payload };
}

export function clearPatientMessages(payload) {
  return { type: CLEAR_PATIENT_MESSAGES, payload };
}

export function createPatientMessage(payload) {
  return { type: CREATE_PATIENT_MESSAGE, payload };
}

export function createPatientMessageSuccess(payload) {
  return { type: CREATE_PATIENT_MESSAGE_SUCCESS, payload };
}

export function createPatientMessageFail(payload) {
  return { type: CREATE_PATIENT_MESSAGE_FAIL, payload };
}

// Requests
export function requestFetchPatientMessages(payload) {
  return payload
    ? callApi(`patient/sms_message/?limit=${payload.limit}&offset=${payload.offset}`)
    : callApi('patient/sms_message/');
}

export function requestSearchPatientMessages({ limit, offset, filters }) {
  return callApi('patient/sms_message/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'ID',
        sort: 'desc',
      },
    ],
    limit,
    offset,
  });
}

export function requestCreatePatientMessage(payload) {
  return callApi('patient/sms_message/', 'POST', payload);
}

// Sagas
function* fetchPatientMessagesSaga(action) {
  const { triggerLoading, filters, push } = action.payload;
  const patientIDFilter = filters.find(item => item.name === 'Patient ID');
  try {
    const res = filters
      ? yield call(requestSearchPatientMessages, action.payload)
      : yield call(requestFetchPatientMessages, action.payload);
    if (push) {
      yield put(fetchPatientMessagesSuccess({
        push: true,
        data: res.data,
        count: res.count,
        ...patientIDFilter ? { patientID: patientIDFilter.val } : {},
        triggerLoading,
      }));
    } else {
      yield put(fetchPatientMessagesSuccess({
        data: res.data,
        count: res.count,
        ...patientIDFilter ? { patientID: patientIDFilter.val } : {},
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchPatientMessagesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createPatientMessageSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    if (values.Document) {
      const { Document, Name, ...otherValues } = values;
      const formData = new FormData();
      formData.append('object_id', values['Patient ID']);
      if (Name) {
        formData.append('file', Document, Name);
      } else {
        formData.append('file', Document);
      }
      const documentRes = yield call(requestCreatePatientDocument, formData);
      const res = yield call(requestCreatePatientMessage, {
        ...otherValues,
        'Document ID': documentRes.data.ID,
      });
      yield put(createPatientMessageSuccess(res.data));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
      yield put(addNotification({
        message: 'Your MMS was successfully sent',
        variant: 'success',
      }));
      if (resolve) {
        resolve(res.data);
      }
    } else {
      const res = yield call(requestCreatePatientMessage, values);
      yield put(createPatientMessageSuccess(res.data));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
      yield put(addNotification({
        message: 'Your SMS was successfully sent',
        variant: 'success',
      }));
      if (resolve) {
        resolve(res.data);
      }
    }
  } catch (err) {
    let errorText = 'Failed to send SMS';
    if (err.data) {
      if (err.data.error) {
        errorText = err.data.error;
      }
      if (err.data.description) {
        errorText = err.data.description;
      }
      if (typeof err.data === 'string') {
        errorText = err.data;
      }
    }
    yield put(createPatientMessageFail(errorText));
    yield put(addNotification({
      message: errorText,
      variant: 'warning',
    }));
    if (reject) {
      reject(errorText);
    }
  }
}

export function* patientsMessagesSaga() {
  yield takeLatest(FETCH_PATIENT_MESSAGES, fetchPatientMessagesSaga);
  yield takeEvery(CREATE_PATIENT_MESSAGE, createPatientMessageSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsMessages.js